import { InjectionToken } from '@angular/core';

export interface IPageSizeStore {
    get(): number;
    set(size: number): void;
    /** Called once by BaseList after the feature route is known. */
    setFeatureKey(featureKey: string): void;
}

export const PAGE_SIZE_STORE = new InjectionToken<IPageSizeStore>('PAGE_SIZE_STORE');

export interface PageSizeEntry {
    /** localStorage key for this feature. Must be unique. */
    storageKey: string;
    /** Page size used before the user has ever changed it. */
    defaultSize: number;
    separate: boolean;
}

/**
 * Map from FeatureRoute.key → PageSizeEntry.
 * Unlisted features fall through to PAGE_SIZE_GLOBAL_DEFAULT.
 * Maintained in ONE place: page-size.config.ts
 */
// export type PageSizeConfig = Record<string, PageSizeEntry>;

export const PAGE_SIZE_CONFIG = new InjectionToken<PageSizeEntry>('PAGE_SIZE_CONFIG');

/**
 * Fallback used when a feature key is not listed in PAGE_SIZE_CONFIG.
 * Override in app.config.ts to change the app-wide default.
 */
export const PAGE_SIZE_GLOBAL_DEFAULT = new InjectionToken<number>('PAGE_SIZE_GLOBAL_DEFAULT', {
    providedIn: 'root',
    factory: () => 10
});
